import * as React from "react";
import ReactDOM from "react-dom";
import { Root } from "./Root";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faCar, faWalking, faWheelchair, faTimesCircle, faThumbsDown, faThumbsUp, faUndo} from "@fortawesome/free-solid-svg-icons";
import {faSquare} from "@fortawesome/free-solid-svg-icons/faSquare";
import {v4 as uuid} from 'uuid';

const hot = (module as any).hot;
if (hot) {
  hot.accept();
}

console.log("VERSION", process.env.GIT_SHA1)
console.log("ENV", process.env.TAG_VERSION || 'local-dev')

const firebaseConfig = {
  apiKey: "AIzaSyC4rRPainqRmiK66HcoXlRNghTaxN2eFrg",
  authDomain: "eyedog.firebaseapp.com",
  databaseURL: "https://eyedog.firebaseio.com",
  projectId: "eyedog",
  storageBucket: "eyedog.appspot.com",
  messagingSenderId: "223420933897",
  appId: "1:223420933897:web:ef1e2114d56f53211295d8",
  measurementId: "G-69Z5K8CH9V"
};
// Initialize Firebase
import * as firebase from 'firebase';
import { AnalyticsEvents } from "./store/AnalyticsStore";
import _ from "lodash";

firebase.initializeApp(firebaseConfig);
export const analytics = firebase.analytics();

let sessionUUID = localStorage.getItem('sessionUUID')
if (_.isEmpty(sessionUUID)) {
  sessionUUID = uuid()
  localStorage.setItem('sessionUUID', sessionUUID);
}

const logEvent = analytics.logEvent
const env = process.env.TAG_VERSION?.match(/^prod/)
  ? 'prod'
  : process.env.TAG_VERSION

analytics.logEvent = function(event: string, data: { [key: string]: any}) {
  logEvent.apply(this, [event, {
    ...(data ?? {}),
    sessionUUID: _.get(data, 'sessionUUID') ?? sessionUUID,
    timestamp: _.get(data, 'timestamp') ?? Date.now(),
    env: env || 'local-dev',
  }])
}

document.addEventListener("visibilitychange",()=>{
  if(document.visibilityState==="hidden"){
    analytics.logEvent(AnalyticsEvents.BecomesIdle)
  }
  else{
    analytics.logEvent(AnalyticsEvents.BecomesVisible)
  }
})


library.add(faCar, faWalking, faSquare, faWheelchair, faUndo, faThumbsUp, faThumbsDown, faTimesCircle);

ReactDOM.render(<Root />, document.getElementById("root"));
